import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { trackEvent } from './md2pro-analytics';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [shopOpen, setShopOpen] = useState(false);
  const shopRef = useRef(null);
  const [navScrolled, setNavScrolled] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [formStatus, setFormStatus] = useState(null); // 'success' | 'error' | null
  const [formSubmitting, setFormSubmitting] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setNavScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!shopOpen) return;
    const handleClickOutside = (e) => {
      if (shopRef.current && !shopRef.current.contains(e.target)) {
        setShopOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [shopOpen]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitting(true);
    setFormStatus(null);

    try {
      const response = await fetch('https://depfrtbrtl.execute-api.us-east-1.amazonaws.com/prod/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        trackEvent('contact_form_submitted');
        setFormStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setFormStatus('error');
      }
    } catch {
      setFormStatus('error');
    } finally {
      setFormSubmitting(false);
    }
  };

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <div className="body">
      {/* NAVBAR */}
      <nav className={`navbar ${navScrolled ? 'scrolled' : ''}`}>
        <a href="#top-website" className="brand">
          <img src="/images/Milili_Logo.svg" alt="Milili Salons" />
        </a>
        <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
          <a href="#about" className="nav-link" onClick={handleNavClick}>About us</a>
          <a href="#services" className="nav-link" onClick={handleNavClick}>Services</a>
          <a href="#locations" className="nav-link" onClick={handleNavClick}>Locations</a>
        </div>
        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span className="icon"></span>
        </button>
      </nav>

      {/* HERO */}
      <section id="top-website" className="hero" style={{ backgroundImage: 'linear-gradient(#6c467885, #6c467885), url(/images/IMG_4069.JPG)' }}>
        <div className="black-banner-wrapper">
          <div className="black-banner">
            <a href="https://www.vagaro.com/mililisalonllc" target="_blank" rel="noopener noreferrer" className="link-block" onClick={() => trackEvent('booking_link_clicked')}>
              <div className="text-block-banner">Book</div>
            </a>
            <div className="shop-dropdown" ref={shopRef}>
              <button
                type="button"
                className="link-block-2 shop-trigger"
                onClick={() => setShopOpen((open) => !open)}
                aria-haspopup="true"
                aria-expanded={shopOpen}
              >
                <div className="text-block-banner">Shop <span className="shop-caret">▾</span></div>
              </button>
              {shopOpen && (
                <div className="shop-menu" role="menu">
                  <a
                    href="https://designessentials.com/?rfsn=3968343.5ac2d1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shop-menu-item"
                    role="menuitem"
                    onClick={() => { trackEvent('shop_link_clicked'); setShopOpen(false); }}
                  >
                    Design Essentials
                  </a>
                  <a
                    href="https://baskandlatherco.com/MililiSalonsLLC"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shop-menu-item"
                    role="menuitem"
                    onClick={() => { trackEvent('shop_link_clicked_bask'); setShopOpen(false); }}
                  >
                    Bask &amp; Lather
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="header-wrapper">
          <div className="vertical-separator"></div>
          <div className="text-wrapper">
            <h1 className="heading"><span className="text-span-13">Relax &amp; Unwind</span></h1>
            <p className="paragraph-hero">Welcome to the Milili Salons Experience</p>
          </div>
        </div>

        <div className="social-wrapper">
          <a href="https://www.facebook.com/MililiSalonsLLC/" target="_blank" rel="noopener noreferrer" className="social-icon-link-block">
            <img src="https://uploads-ssl.webflow.com/5bc45fb45a5ed9a3be715550/5bc5a207eb16de1bea19edf7_facebook-logo-button.svg" alt="Facebook" />
          </a>
          <a href="https://twitter.com/mililisalons3" target="_blank" rel="noopener noreferrer" className="social-icon-link-block">
            <img src="https://uploads-ssl.webflow.com/5bc45fb45a5ed9a3be715550/5bc5a20a47aadeb28860ed42_twitter-logo-button.svg" alt="Twitter" />
          </a>
          <a href="https://www.instagram.com/mililisalons/" target="_blank" rel="noopener noreferrer" className="social-icon-link-block">
            <img src="https://uploads-ssl.webflow.com/5bc45fb45a5ed9a3be715550/5bc5a21362d140cd31065f63_instagram-logo.svg" alt="Instagram" />
          </a>
        </div>
      </section>

      {/* ABOUT US */}
      <section id="about" className="about-us">
        <div className="about-text-wrapper">
          <div className="text-block-8">OUR STORY</div>
          <h2 className="heading-3">About us</h2>
          <p className="about-paragraph-1">
            Pronounced (Ma'Lilie) Named after the salon owners late grandmother Lillie Beatrice Johnson. Milili Salons is an elegant upscale salon known for it's inviting and pleasant atmosphere. The hallmark of Milili Salons is "relax and unwind". Providing a relaxing experience, expert customer satisfaction and a comfortable get away from the everyday stresses of life is our goal. Our stylists are certified and on the cutting edge of trends, techniques, products and Styles.
          </p>
          <div className="signature-wrapper">
            <div className="text-block-7">Milili Salons</div>
          </div>
        </div>
      </section>

      {/* GALLERY 2 */}
      <section className="gallery-2">
        <div className="gallery-grid">
          <div className="gallery-cell div-block-48" style={{ backgroundImage: 'linear-gradient(#6c46786b, #6c46786b), url(/images/milili_stock6.jpg)' }}>
            <div className="gallery-overlay">
              <img src="/images/Milili_Celeste.svg" alt="Milili" />
            </div>
          </div>
          <div className="div-block-45">
            <div className="text-block-23">Relax &amp; Unwind</div>
          </div>
          <div className="gallery-cell div-block-47" style={{ backgroundImage: 'linear-gradient(#6c46786b, #6c46786b), url(/images/aw-creative-VjRpkGtS55w-unsplash.jpg)' }}>
            <div className="gallery-overlay">
              <img src="/images/Milili_Celeste.svg" alt="Milili" />
            </div>
          </div>
          <div className="gallery-cell div-block-46" style={{ backgroundImage: 'linear-gradient(#6c46786b, #6c46786b), url(/images/Hair_Supplies.jpg)' }}>
            <div className="gallery-overlay">
              <img src="/images/Milili_Celeste.svg" alt="Milili" />
            </div>
          </div>
          <div className="div-block-49">
            <p className="paragraph-9">A woman who cuts her hair is about to change her life.</p>
            <div className="text-block-24">-Coco Chanel</div>
          </div>
          <div className="gallery-cell div-block-50" style={{ backgroundImage: 'linear-gradient(#6c46786b, #6c46786b), url(/images/Milili_BW_-1-of-3.jpg)' }}>
            <div className="gallery-overlay">
              <img src="/images/MililiWhole_Celeste.svg" alt="Milili" />
            </div>
          </div>
          <div className="gallery-cell div-block-51" style={{ backgroundImage: 'linear-gradient(#6c46786b, #6c46786b), url(/images/milili_stock4.jpg)' }}>
            <div className="gallery-overlay">
              <img src="/images/MililiWhole_Celeste.svg" alt="Milili" />
            </div>
          </div>
          <div className="gallery-cell div-block-52" style={{ backgroundImage: 'linear-gradient(#6c46786b, #6c46786b), url(/images/Milili_BW_-3-of-3.jpg)' }}>
            <div className="gallery-overlay">
              <img src="/images/Milili_Celeste.svg" alt="Milili" />
            </div>
          </div>
          <div className="div-block-53">
            <a href="https://designessentials.com/?rfsn=3968343.5ac2d1" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }} onClick={() => trackEvent('shop_link_clicked')}>
              <div className="text-block-25">PRODUCTS &rarr;</div>
            </a>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="services">
        <h2 className="services-head">Our Services</h2>
        <div className="card-wrapper">
          <div className="service-card">
            <img src="/images/MililiIcon_3.svg" alt="Styling" />
            <h3 className="heading-4">Styling</h3>
            <div className="text-block-26">Milili will help you reinvent your image with a Trim or a modern short style.</div>
          </div>
          <div className="service-card">
            <img src="/images/MililiIcon_2.svg" alt="Cuts" />
            <h3 className="heading-4">cuts</h3>
            <div className="text-block-26">Revive and revitalize your hair with MIlili's intimate Shampooing experience. Let us elevate your hair with expert styling or a silk press.</div>
          </div>
          <div className="service-card">
            <img src="/images/MililiIcon_1.svg" alt="Relaxers" />
            <h3 className="heading-4">relaxers</h3>
            <div className="text-block-26">For easy maintenance, Milili's relaxer treatments are the perfect solution. We specialize in Virgin relaxers, Partial Starts and Re-touches.</div>
          </div>
          <div className="service-card">
            <img src="/images/PurpleAsset-3Comb.png" alt="Color" />
            <h3 className="heading-4">Color</h3>
            <div className="text-block-26">Feeling bold? MIlili can give you that extra pop of color you've been desiring. You can choose Color Correction, Partial highlights, Full highlights and Single process.</div>
          </div>
          <div className="service-card">
            <img src="/images/Milili_Prdcts_Purple.svg" alt="Keratin" />
            <h3 className="heading-4">Keratin smoothing treatments</h3>
            <div className="text-block-26">Looking for an elegant hair treatment that will last? Keratin provides a softer look while providing a long lasting shine.</div>
          </div>
          <div className="service-card">
            <img src="/images/MililiIcon_4.svg" alt="Extensions" />
            <h3 className="heading-4">extension services</h3>
            <div className="text-block-26">Milili can assist you at every stage of your journey. We specialize in weave maintenance, sew-ins, and extension removal.</div>
          </div>
        </div>
        <a href="https://www.vagaro.com/us04/mililisalonllc" target="_blank" rel="noopener noreferrer" className="button-2" onClick={() => trackEvent('booking_link_clicked')}>Book Now</a>
      </section>

      {/* PARALLAX TESTIMONIALS */}
      <section className="parallax" style={{ backgroundImage: 'linear-gradient(#2c0735cc, #2c0735cc), url(/images/Milili_BW_-3-of-12.jpg)' }}>
        <div className="parallax-text-wrapper">
          <div className="columns-2">
            <div className="column-9">
              <p className="quote-text">"...The staff was great and appreciated the positive vibes, which made the atmosphere excellent to be in."</p>
              <div className="quote-name">-Valerie E.</div>
            </div>
            <div className="column-9">
              <p className="quote-text">"She was very welcoming and knew how i wanted my hair done."</p>
              <div className="quote-name">-Carisa M.</div>
            </div>
            <div className="column-9">
              <p className="quote-text">"Very professional and knowledge!!! Very nice salon and spa! Comfortable and friendly seating; very easy to get to!!!"</p>
              <div className="quote-name">-Carissa S.</div>
            </div>
          </div>
        </div>
      </section>

      {/* OPENING HOURS */}
      <section className="opening-hours">
        <div className="opening-head-wrapper">
          <h2 className="heading-3">Opening Hours</h2>
        </div>
        <div className="opening-hours-wrapper">
          <div className="day-card monday" style={{ backgroundImage: 'linear-gradient(#2c073585, #2c073585), url(/images/Milili_BW_-12-of-12.jpg)' }}>
            <div className="div-block-19">
              <div className="text-block-9">Mon</div>
            </div>
            <div className="hours-container">
              <div className="right-hours">
                <div className="mon-text">Closed</div>
              </div>
            </div>
          </div>
          <div className="day-card thursday" style={{ backgroundImage: 'linear-gradient(#2c073585, #2c073585), url(/images/Milili_BW_-2-of-12.jpg)' }}>
            <div className="div-block-19">
              <div className="text-block-9">Thu</div>
            </div>
            <div className="hours-container">
              <div className="full-hours-2">
                <div className="mon-text">9:00am to 7:00pm</div>
              </div>
            </div>
          </div>
          <div className="day-card tuesday" style={{ backgroundImage: 'linear-gradient(#2c073585, #2c073585), url(/images/Milili_BW_-8-of-12.jpg)' }}>
            <div className="div-block-19">
              <div className="text-block-9">Tue</div>
            </div>
            <div className="hours-container">
              <div className="full-hours">
                <div className="wed-hours">Closed</div>
              </div>
            </div>
          </div>
          <div className="day-card wednesday" style={{ backgroundImage: 'linear-gradient(#2c073585, #2c073585), url(/images/Milili_BW_-11-of-12.jpg)' }}>
            <div className="div-block-19">
              <div className="text-block-9">Wed</div>
            </div>
            <div className="hours-wrapper-centered">
              <div className="text-block-22">Closed</div>
            </div>
          </div>
          <div className="day-card friday" style={{ backgroundImage: 'linear-gradient(#2c073585, #2c073585), url(/images/Milili_BW_-6-of-12.jpg)' }}>
            <div className="div-block-19">
              <div className="text-block-9">Fri</div>
            </div>
            <div className="hours-container">
              <div className="right-hours">
                <div className="mon-text">9:00am to 7:00pm</div>
              </div>
            </div>
          </div>
          <div className="day-card saturday" style={{ backgroundImage: 'linear-gradient(#2c073585, #2c073585), url(/images/Milili_BW_-9-of-12.jpg)' }}>
            <div className="div-block-19">
              <div className="text-block-9">Sat</div>
            </div>
            <div className="hours-container">
              <div className="full-hours">
                <div className="sat-text">7:00am to 4:00pm</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THE OWNER */}
      <section className="section-3">
        <div className="w-container">
          <h2 className="parallax-head-owner">The Owner</h2>
          <div className="div-block-43">
            <div className="div-block-44">
              <p className="paragraph-8">
                Rhonda Burns is the owner of Milili Salons located in Crest Hill, Illinois. After a 15-year corporate career, She left her job to pursue her passion in the hair industry. She started working in salons to get a feel for the industry. Rhonda is now a certified advanced Hair Colorist and Graduate of Dudleys Beauty College Cosmetology and Cosmetology Instructors program. She is also certified in advanced hair cutting and make up artistry(MUA).
              </p>
              <div className="quote-name">Rhonda Jackson</div>
            </div>
            <div className="div-block-42" style={{ backgroundImage: 'url(/images/rhonda_hairstyle.jpg)' }}></div>
          </div>
        </div>
      </section>

      {/* CONTACT US */}
      <section id="book" className="book">
        <div className="appointment-wrapper">
          <h2 className="book-header">Contact Us</h2>
          <p className="paragraph-5">Give us a call today and book an experience with Milili Salons.</p>
          <div className="div-block-30">
            <div className="form-block">
              <form onSubmit={handleSubmit}>
                <input
                  className="text-field"
                  maxLength="256"
                  name="name"
                  placeholder="Name"
                  type="text"
                  required
                  value={formData.name}
                  onChange={handleInputChange}
                />
                <input
                  className="text-field-2"
                  maxLength="256"
                  name="email"
                  placeholder="e-mail"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                />
                <textarea
                  name="message"
                  placeholder="Message"
                  maxLength="5000"
                  className="textarea"
                  value={formData.message}
                  onChange={handleInputChange}
                ></textarea>
                <button type="submit" className="submit-button" disabled={formSubmitting}>
                  {formSubmitting ? 'Please wait...' : 'Submit →'}
                </button>
              </form>
              {formStatus === 'success' && (
                <div className="form-success">Thank you! Your submission has been received!</div>
              )}
              {formStatus === 'error' && (
                <div className="form-error">Oops! Something went wrong while submitting the form.</div>
              )}
            </div>
            <div className="div-block-31">
              <ul className="unordered-list">
                <li className="list-item">
                  <div className="service-contact">
                    <img src="/images/sign-post.svg" alt="Address" className="address-icon" />
                    <div className="text-block-12">
                      <a href="https://www.google.com/maps/place/Milili+Salons/@41.591484,-88.1239627,17z" target="_blank" rel="noopener noreferrer" className="link-9">2250 Weber Rd. Crest Hill, IL 60432</a>
                    </div>
                  </div>
                </li>
                <li className="list-item-2">
                  <div className="service-contact">
                    <img src="/images/telephone.svg" alt="Phone" className="address-icon" />
                    <div className="text-block-12">
                      <a href="tel:+18558834247" className="link-9">(855)883-4247</a>
                    </div>
                  </div>
                </li>
                <li className="list-item-3">
                  <div className="service-contact">
                    <img src="/images/email.svg" alt="Email" className="address-icon" />
                    <div className="text-block-12">
                      <a href="mailto:mililisalons@gmail.com?subject=General%20Inquiry" className="link-9">mililisalons@gmail.com</a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* VIDEO / LOCATIONS */}
      <section className="video-background">
        <div className="background-video">
          <video autoPlay loop muted playsInline style={{ objectFit: 'cover', width: '100%', height: '100%' }} poster="/videos/New-York-City---1044-poster-00001.jpg">
            <source src="/videos/New-York-City---1044-transcode.mp4" type="video/mp4" />
          </video>
          <div id="locations" className="video-opacity">
            <div className="locations-wrapper">
              <div className="city-wrapper">
                <h3 className="heading-7">Crest Hill, IL</h3>
                <p className="paragraph-6">Relax &amp; Unwind in Illinois premier salon experience.</p>
                <ul className="card-list">
                  <li className="list-item">
                    <div className="service-contact">
                      <a href="https://www.google.com/maps/place/Milili+Salons/@41.591484,-88.1239627,17z" target="_blank" rel="noopener noreferrer">
                        <div className="text-block-location">2250 Weber Rd. Crest Hill, IL 60432</div>
                      </a>
                    </div>
                  </li>
                  <li className="list-item-2">
                    <div className="service-contact">
                      <a href="tel:+18558834247">
                        <div className="text-block-location">(855)883-4247</div>
                      </a>
                    </div>
                  </li>
                  <li className="list-item-3">
                    <div className="service-contact">
                      <a href="mailto:mililisalons@gmail.com?subject=General%20Inquiry">
                        <div className="text-block-location">mililisalons@gmail.com</div>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <a href="#top-website" className="footer-logo">
          <img src="/images/Milili_Logo.svg" alt="Milili Salons" />
        </a>
        <h3 className="heading-6 heading-6-info">Information</h3>
        <h3 className="heading-6 heading-6-locations">Locations</h3>
        <h3 className="heading-6 heading-6-follow">Follow Us</h3>
        <a href="#about" className="footer-link footer-about">
          <div className="text-block-16">About us</div>
        </a>
        <a href="#book" className="footer-link footer-contact">
          <div className="text-block-16">Contact us</div>
        </a>
        <a href="https://www.google.com/maps/place/Milili+Salons/@41.591484,-88.1239627,17z" target="_blank" rel="noopener noreferrer" className="footer-link footer-cresthill">
          <div className="text-block-16">Crest Hill</div>
        </a>
        <a href="https://www.facebook.com/MililiSalonsLLC/" target="_blank" rel="noopener noreferrer" className="footer-link footer-facebook">
          <div className="text-block-16">Facebook</div>
        </a>
        <a href="https://www.instagram.com/mililisalons/" target="_blank" rel="noopener noreferrer" className="footer-link footer-instagram">
          <div className="text-block-16">Instagram</div>
        </a>
        <a href="https://twitter.com/mililisalons3" target="_blank" rel="noopener noreferrer" className="footer-link footer-twitter">
          <div className="text-block-16">Twitter</div>
        </a>
      </footer>
    </div>
  );
}

export default App;
